import pajaro_home from '../../imagenes/pajaro_home.png'

export default function Home(){
    return (
        <div className="bg-custom container-custom flex justify-center items-center">           
                <img src={pajaro_home}></img>            
        </div>
    )
}